import { CardComponent, cardTemplate } from './Card';
import styles from './Card.styles.scss';
export const cardDefinition = {
    baseName: 'card',
    template: cardTemplate,
    styles,
};
export const chameleonCard = CardComponent.compose(cardDefinition);
